// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fImPblcI3zETaf {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
}
.grpHyNhY8LVEzB {
  position: relative;
  flex-grow: 1;
  overflow-y: auto;
  outline: none;
}
`, ""]);
// Exports
export var contentWrapper = `fImPblcI3zETaf`;
export var content = `grpHyNhY8LVEzB`;
export default ___CSS_LOADER_EXPORT___;
